import { z } from "zod";
import { channelCannotOpenSchema } from "./resource-references.js";
/** Explicit sharing grants channel readers read access to a session only. */
export const sessionLinkInputSchema = z.object({
    channelId: z.string().trim().min(1).max(200),
}).strict();
export const attachSessionResponseSchema = z.object({
    attached: z.boolean(),
    /** Sharing a session shares its conversation; its documents and files that some readers still cannot open are named here. */
    channelCannotOpen: channelCannotOpenSchema.optional(),
}).strict();
export const detachSessionResponseSchema = z.object({ detached: z.boolean() }).strict();
